import { ContentfulImage } from '@components/contentful-image'
import type { ContentfulImageFragment } from '@graphql/fragments/ContentfulImageFragment.graphql'
import type { FunctionComponent } from 'react'

import styles from './article-image.module.scss'

/**
 * Dispays a standalone image section.
 */
export const ArticleImage: FunctionComponent<ContentfulImageFragment> = (
    image,
) => (
    <div className={styles.section}>
        <ContentfulImage
            url={image.url}
            alt={image.alt}
            width={image.width}
            height={image.height}
            contentType={image.contentType}
            sizes='100vw'
            style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
        />
    </div>
)
